export enum WorkflowExecutionState {
  Active = 'active',
  Inactive = 'inactive',
}

export enum WorkflowExecutionStatus {
  Running = 'running',
  Waiting = 'waiting',
  Held = 'held',
  Succeeded = 'succeeded',
  Failed = 'failed',
  Canceled = 'canceled',
  Aborted = 'aborted',
}

export interface GetWorkflowHistoryResponse {
  workflowExecutions: WorkflowExecution[];
  continuationToken?: string;
}

export interface WorkflowExecution {
  workflowExecutionUUID: string;
  workflowUUID: string;
  workflowVersion: number;
  modifiedByUserID: string;
  modifiedDateTimeUTC: string;
  correlationUUID: string;
  state: WorkflowExecutionState;
  status: WorkflowExecutionStatus;
}

export interface WorkflowExecutionDetails extends WorkflowExecution {
  workflowExecutionUUID: string;
  workflowUUID: string;
  workflowVersion: number;
  modifiedByUserID: string;
  modifiedDateTimeUTC: string;
  correlationUUID: string;
  state: WorkflowExecutionState;
  steps: WorkflowExecutionStep[];
}

interface WorkflowExecutionStep {
  name: string;
  status: string;
  input: any;
  beganDateTimeUTC: string;
  output?: any;
  endedDateTimeUTC?: string;
}
